// extracted by mini-css-extract-plugin
export default {"wiki_title":"WikiContent_wiki_title__O3TH3","wiki_subtitle":"WikiContent_wiki_subtitle__2Ku8c","wiki":"WikiContent_wiki__AZPYs"};